import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    isFormLoading: false,
    isFormLoaded: false,
    isCapturing: false,
    isCaptured: false,
    apiAccessToken: '',
    error: null,
    listingCannotBeActivated: false,
});

const reducer = (state = initState(), action) => {
    switch (action.type) {
        case DispatchConstants.LISTING_CANNOT_BE_ACTIVATED:
            return { ...state, listingCannotBeActivated: true, error: action.payload };
        case DispatchConstants.INITIATE_CREDIT_CARD_CAPTURE_SUCCESS:
            return { ...state, apiAccessToken: action.payload.apiAccessToken };
        case DispatchConstants.CREDIT_CARD_FORM_LOADING:
            return { ...state, isFormLoading: true, isFormLoaded: false };
        case DispatchConstants.CREDIT_CARD_FORM_LOAD_COMPLETE:
            return { ...state, isFormLoading: false, isFormLoaded: true };
        case DispatchConstants.CREDIT_CARD_FORM_SUBMITTING:
            return { ...state, isCapturing: true };
        case DispatchConstants.CREDIT_CARD_FORM_SUBMIT_SUCCESS:
            return { ...state, error: null };
        case DispatchConstants.VERIFY_CREDIT_CARD_CAPTURE_SUCCESS:
            return { ...state, isCapturing: false, isCaptured: true };
        case DispatchConstants.INITIATE_CREDIT_CARD_CAPTURE_FAIL:
        case DispatchConstants.CREDIT_CARD_FORM_SUBMIT_FAIL:
        case DispatchConstants.VERIFY_CREDIT_CARD_CAPTURE_FAIL:
            return { ...state, isCapturing: false, error: action.payload };
        case DispatchConstants.MODAL_HIDE:
            return initState();
        default:
    }
    return state;
};

export default reducer;
